export default function arrayPrepare(data) {
  const groupsByImplemento = new Map();

  data.forEach((rastro) => {
    const group = groupsByImplemento.get(rastro.implemento);

    if (group) {
      group.push(rastro);
      return;
    }

    groupsByImplemento.set(rastro.implemento, [rastro]);
  });

  return Array.from(groupsByImplemento.values());
}
